import { isDateInRange } from '@libs/core';
import type { EligiblePromotion } from '@libs/common-types';
import moment from 'moment-timezone';

export const filterActiveAlgoliaPromotions = (
    promotions: EligiblePromotion[]
) => {
    const currentDate = moment().tz('America/Phoenix').toDate();
    return promotions.filter(
        ({ promoStart, promoEnd, promoText }) =>
            isDateInRange(currentDate, [promoStart, promoEnd]) && !!promoText
    );
};
